import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

// Use environment variable or default to local backend
const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3013/api";

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(() => {
        const token = localStorage.getItem("token");
        return token ? { token } : null; // Initialize user with token if present
    });

    // Ensure auth state is loaded on mount
    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            setUser({ token });
        }
    }, []);

    const login = async (email, password) => {
        try {
            const response = await fetch(`${API_BASE_URL}/auth/login`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ username: email, password }),
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || "Invalid credentials");
            }

            const data = await response.json();
            if (data.token) {
                localStorage.setItem("token", data.token);
                setUser({ token: data.token });
                return { success: true };
            } else {
                return { success: false, message: data.message || "Login failed" };
            }
        } catch (error) {
            return { success: false, message: error.message || "Network error" };
        }
    };

    const logout = () => {
        localStorage.removeItem("token");
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
